<template>
  <div class="general">
    <a-form :style="{ '--recipients-max-height': recipientsMaxHeight }">
      <a-form-item label="De:" v-if="emailTransmitter" class="identifier">
        <!-- <p>{{ transmitter }}</p> -->
        <p>{{ emailFrom(formState.fromEmail) }}</p>
        <div class="transfer">
          <IconFolderArrow small />
          <a-button type="link" @click="handleChangeEmailFrom"
            >Responder desde otro identificador</a-button
          >
        </div>
      </a-form-item>
      <a-form-item label="De:" v-else>
        <a-select
          :getPopupContainer="getPopupContainer"
          class="form-item-xl"
          placeholder="Seleccionar correo"
          :filter-option="false"
          mode="single"
          v-model:value="selectedFromOption"
          @change="handleFromChange"
        >
          <template v-for="option in addresseeOptions" :key="option.id">
            <!-- Identifier principal -->
            <a-select-option :value="`id:${option.id}`">
              <div class="option">
                <span>{{ option.email }}</span>
                <p>{{ option.name }}</p>
              </div>
            </a-select-option>
            <!-- Aliases del identificador -->
            <template v-if="aliasesPerIdentifier[option.id]">
              <a-select-option
                v-for="alias in aliasesPerIdentifier[option.id]"
                :key="`alias:${option.id}:${alias.email}`"
                :value="`alias:${option.id}:${alias.email}`"
              >
                <div class="option">
                  <span>{{ alias.email }}</span>
                  <p>{{ option.name }} ({{ option.email }})</p>
                </div>
              </a-select-option>
            </template>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item label="Para:" class="send-email">
        <div class="flex-container" @paste="(e) => handleEmailPaste(e, 'selectedItems')">
          <div style="flex: 1"
            @keydown.capture="(e: KeyboardEvent) => handleKeydown(e, 'selectedItems')">
            <a-select ref="selectParaRef" :key="selectKeyPara" :getPopupContainer="getPopupContainer" class="form-item-xl"
              placeholder="Seleccionar identificador" show-search :filter-option="false"
              v-model:value="formState.selectedItems" v-model:search-value="searchValuePara" mode="multiple"
              @search="handleSearch($event, 'selectedItems')" @blur="handleBlur('selectedItems')"
              style="width: 100%">
            <template #tagRender="{ closable, onClose, value }">
              <a-tag
                :closable="closable"
                :color="getTagColor(value)"
                style="margin-right: 3px"
                @close="onClose"
              >
                <template v-if="shouldRenderIcon(value)">
                  <component :is="getTagIcon(value)" />
                </template>
                <template v-else>
                  <component :is="getTagIcon(value)" />
                  {{ value }}&nbsp;&nbsp;
                </template>
                <template v-if="shouldRenderPopover(value)">
                  <a-popover trigger="hover">
                    <template #content>
                      <h4>{{ displayName(value) }}</h4>
                      <p>Correo: {{ value }}</p>
                    </template>
                    {{ value }}&nbsp;&nbsp;
                  </a-popover>
                </template>
              </a-tag>
            </template>
            <a-select-option v-for="option in options" :key="option.email">
              <div class="option">
                <p>{{ option.name }}</p>
                <span>{{ option.email }}</span>
              </div>
            </a-select-option>
          </a-select>
          </div>
          <div class="link">
            <a-button type="link" v-if="!showCC" @click="showCC = true">CC</a-button>
            <a-button type="link" v-if="!showCCO && !showCC" @click="showCCO = true">CCO</a-button>
          </div>
        </div>
      </a-form-item>
      <a-form-item label="CC:" class="send-email" v-if="showCC">
        <div class="flex-container" @paste="(e) => handleEmailPaste(e, 'selectedItemsCC')">
          <div style="flex: 1"
            @keydown.capture="(e: KeyboardEvent) => handleKeydown(e, 'selectedItemsCC')">
            <a-select ref="selectCCRef" :key="selectKeyCC" :getPopupContainer="getPopupContainer" class="form-item-xl"
              placeholder="Seleccionar identificador" show-search :filter-option="false"
              v-model:value="formState.selectedItemsCC" v-model:search-value="searchValueCC" mode="multiple"
              @search="handleSearch($event, 'selectedItemsCC')" @blur="handleBlur('selectedItemsCC')"
              style="width: 100%">
            <template #tagRender="{ closable, onClose, value }">
              <a-tag
                :closable="closable"
                :color="getTagColor(value)"
                style="margin-right: 3px"
                @close="onClose"
              >
                <template v-if="shouldRenderIcon(value)">
                  <component :is="getTagIcon(value)" />
                </template>
                <template v-else>
                  <component :is="getTagIcon(value)" />
                  {{ value }}&nbsp;&nbsp;
                </template>
                <template v-if="shouldRenderPopover(value)">
                  <a-popover trigger="hover">
                    <template #content>
                      <h4>{{ displayName(value) }}</h4>
                      <p>Correo: {{ value }}</p>
                    </template>
                    {{ displayName(value) }}&nbsp;&nbsp;
                  </a-popover>
                </template>
              </a-tag>
            </template>
            <a-select-option v-for="option in options" :key="option.email">
              <div class="option">
                <p>{{ option.name }}</p>
                <span>{{ option.email }}</span>
              </div>
            </a-select-option>
          </a-select>
          </div>
          <div class="link">
            <a-button type="link" v-if="!showCCO" @click="showCCO = true">CCO</a-button>
          </div>
        </div>
      </a-form-item>
      <a-form-item label="CCO:" class="send-email" v-if="showCCO">
        <div class="flex-container" @paste="(e) => handleEmailPaste(e, 'selectedItemsCCO')">
          <div style="flex: 1"
            @keydown.capture="(e: KeyboardEvent) => handleKeydown(e, 'selectedItemsCCO')">
            <a-select ref="selectCCORef" :key="selectKeyCCO" :getPopupContainer="getPopupContainer" class="form-item-xl"
              placeholder="Seleccionar identificador" show-search :filter-option="false"
              v-model:value="formState.selectedItemsCCO" v-model:search-value="searchValueCCO" mode="multiple"
              @search="handleSearch($event, 'selectedItemsCCO')" @blur="handleBlur('selectedItemsCCO')"
              style="width: 100%">
            <template #tagRender="{ closable, onClose, value }">
              <a-tag
                :closable="closable"
                :color="getTagColor(value)"
                style="margin-right: 3px"
                @close="onClose"
              >
                <template v-if="shouldRenderIcon(value)">
                  <component :is="getTagIcon(value)" />
                </template>
                <template v-else>
                  <component :is="getTagIcon(value)" />
                  {{ value }}&nbsp;&nbsp;
                </template>
                <template v-if="shouldRenderPopover(value)">
                  <a-popover trigger="hover">
                    <template #content>
                      <h4>{{ displayName(value) }}</h4>
                      <p>Correo: {{ value }}</p>
                    </template>
                    {{ displayName(value) }}&nbsp;&nbsp;
                  </a-popover>
                </template>
              </a-tag>
            </template>
            <a-select-option v-for="option in options" :key="option.email">
              <div class="option">
                <p>{{ option.name }}</p>
                <span>{{ option.email }}</span>
              </div>
            </a-select-option>
          </a-select>
          </div>
        </div>
      </a-form-item>
      <a-form-item label="Asunto:">
        <a-input v-model:value="formState.subject" placeholder="Escribir asunto..." />
      </a-form-item>
    </a-form>
    <div
      class="editor-drop-zone"
      @click.capture="handleTemplateCardActionClick"
      @paste="handlePasteFile"
      @dragover.prevent
      @drop.prevent="handleDropFile"
    >
      <EditorComponent
        v-model="formState.text"
        @ready="handleEditorReady"
        @destroy="handleEditorDestroy"
      />
    </div>
    <InputActionButtons
      v-model:file="file"
      v-model:files="files"
      :editor-html="formState.text"
      :has-template="true"
      @select-emoji="handleAddEmoji"
      @insert-template="handleInsertTemplate"
      multiple 
      files-reduce
      :validate-total-size="VALIDATE_TOTAL_SIZE"
      :max-total-size-m-b="MAX_TOTAL_SIZE_MB"
      :max-file-size-m-b="MAX_FILE_SIZE_MB"
    />
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, inject, Ref, watch, nextTick, onMounted } from "vue";
import { UserOutlined, UserAddOutlined, CloseCircleOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import IconFolderArrow from "@/app/common/components/atoms/IconFolderArrow.vue";
import EditorComponent from "@/app/emails/components/editor/Editor.vue";
// import { emailService } from "@/app/emails/services/Email.service";
import InputActionButtons from "@/app/shared/components/buttons/InputActionButtons.vue";
import { IMenutem, EmailForm, DRAFT_KEY } from "@/@types/emails";
import { useStore } from "vuex";
import { debounce } from "lodash";
import { emailService } from "@/app/emails/services/Email.service";
import { useFileHandler } from "@/app/shared/composables/useFileHandler";
import type { Editor as CKEditorInstance } from "ckeditor5";
import { fetchSendAsAliases } from "@/app/channels/services"

const selectParaRef = ref();
const selectCCRef = ref();
const selectCCORef = ref();

const props = defineProps({
  open: { type: Boolean, default: false },
  emailTransmitter: { type: Boolean, default: false },
  isReply: { type: Boolean, default: false },
});

const formState: Ref<EmailForm> =
  inject("emailFromResponse") ??
  ref({
    fromEmail: null,
    sendAsAlias: null,
    selectedItems: [],
    selectedItemsCC: [],
    selectedItemsCCO: [],
    subject: "",
    text: "",
    defaultSignatureApplied: false,
  });

const emit = defineEmits(["handleChangeEmailFrom"]);

const VALIDATE_TOTAL_SIZE = true
const MAX_TOTAL_SIZE_MB = 10
const MAX_FILE_SIZE_MB = 10

const {
  validateFileMultiple,
  filesValidatedByType,
  isValidFileType,
} = useFileHandler({
  multiple: true,
  validatePerType: true,

  validateTotalSize: VALIDATE_TOTAL_SIZE,
  maxTotalSizeMB: MAX_TOTAL_SIZE_MB,
  maxFileSizeMB: MAX_FILE_SIZE_MB,
});

const file = ref<File>();
const files = ref<File[]>();

const getAllDrafts = () => {
  try {
    return JSON.parse(localStorage.getItem(DRAFT_KEY) || '{}') || {};
  } catch {
    return {};
  }
};

const hasSameDraftFiles = (localFiles: any[] = [], currentFiles: File[] = []) => {
  if (localFiles.length !== currentFiles.length) return false;

  return localFiles.every((localFile, index) => {
    const currentFile = currentFiles[index];

    return (
      currentFile &&
      localFile.name === currentFile.name &&
      localFile.size === currentFile.size &&
      localFile.type === currentFile.type &&
      localFile.lastModified === currentFile.lastModified
    );
  });
};

const syncFilesFromVuexIfNeeded = () => {
  const userId = localStorage.getItem("used_id");

  if (!userId) return;

  const existing = getAllDrafts();
  const localDraft = existing[userId];

  const localFiles = localDraft?.files ?? [];
  const vuexFiles = store.getters["getDraftFiles"]?.(userId) ?? [];

  console.log(localFiles, 'draft files localFiles');
  console.log(vuexFiles, 'draft files vuexFiles');
  console.log(localFiles.length > 0, 'draft files localFiles.length > 0');
  console.log(vuexFiles.length > 0, 'draft files vuexFiles.length > 0');
  console.log(!hasSameDraftFiles(localFiles, files.value ?? []), 'draft files !hasSameDraftFiles(localFiles, files.value ?? [])');
  if (
    localFiles.length > 0 &&
    vuexFiles.length > 0 &&
    !hasSameDraftFiles(localFiles, files.value ?? [])
  ) {
    files.value = vuexFiles;
  }
};

const saveDraft = debounce((data: { changeFile: boolean } = { changeFile: false }) => {
  try {
    const userId = localStorage.getItem("used_id");

    console.log('draft files userId: ', userId);
    if (!userId) return;

    if (!data.changeFile)
      syncFilesFromVuexIfNeeded();

    console.log('draft files files.value', files.value)
    
    const draft = {
      ...formState.value,
      files: (files.value ?? []).map((file: File) => ({
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified,
      })),
    };

    // 1. Leer lo que ya existe
    const existing = getAllDrafts();

    console.log('draft files existing: ', existing);

    // 2. Asignar por userId
    existing[userId] = draft;

    // 3. Guardar nuevamente
    localStorage.setItem(DRAFT_KEY, JSON.stringify(existing));

    // 4. Archivos reales solo en Vuex
    store.dispatch("setDraftFiles", {
      userId,
      files: files.value ?? [],
    });
  } catch (error) {
    console.error("Error guardando borrador:", error);
  }
}, 800);

watch(
  () => formState.value,
  () => {
    console.log('draft files reconoce edicion de formState: ', files.value)
    if (!props.isReply) {
      saveDraft();
    }
  },
  { deep: true }
);

watch(
  () => files.value,
  () => {
    console.log('draft files reconoce edicion de files: ', files.value)
    if (!props.isReply) {
      saveDraft({ changeFile: true });
    }
  },
  { deep: true }
);

const selectedCampaign = computed(() => {
  return store.getters.getSelectedCampaign;
});

const fromEmailAddress = computed(() => {
  if (formState.value.sendAsAlias) return formState.value.sendAsAlias;
  const selected = addresseeOptions.value.find((option: { email: string, id: number}) => option.id === Number(formState.value.fromEmail) || option.email === formState.value.fromEmail)
  return selected?.email ?? null
})

/*** Copy Paste Files ***/
const processIncomingFiles = (rawFiles: File[]) => {
  if (!rawFiles.length) return;

  // convertir a FileList-like
  const dataTransfer = new DataTransfer();
  rawFiles.forEach(f => dataTransfer.items.add(f));

  // 1. tamaño
  const filesValidated = validateFileMultiple(dataTransfer.files);

  // 2. tipo
  const typeValidated = filesValidated.filter(file => isValidFileType(file));

  // 3. límite por tipo
  const validatedByType = filesValidatedByType(typeValidated, files.value || []);

  if (validatedByType.length < filesValidated.length) {
    message.error("Se excedió el límite máximo de 5 archivos por tipo (imágenes, videos o documentos)");
  }

  // 4. merge
  files.value = [...(files.value || []), ...validatedByType];
};

const handlePasteFile = (event: ClipboardEvent) => {
  const items = event.clipboardData?.items;
  if (!items) return;

  const rawFiles: File[] = [];

  for (const item of items) {
    if (item.kind === "file") {
      const file = item.getAsFile();
      if (file) rawFiles.push(file);
    }
  }

  if (!rawFiles.length) return;

  event.preventDefault();
  processIncomingFiles(rawFiles);
};

/*** Drag & drop files ***/
const handleDropFile = (event: DragEvent) => {
  const rawFiles = Array.from(event.dataTransfer?.files || []);
  if (!rawFiles.length) return;

  event.preventDefault();
  processIncomingFiles(rawFiles);
};

const emailFrom = (email: string | null | number) => {
  if (!email) return "";
  const emailFind = addresseeOptions.value.find((el: { email: string; id: number }) => el.email == email || el.id == email);
  if (emailFind) {
    if (formState.value.sendAsAlias) {
      return `${emailFind.name} <${formState.value.sendAsAlias}>`;
    }
    return `${emailFind.name} <${emailFind.email}>`;
  }
  return email;
};

const TEMPLATE_CARD_SELECTOR = '[data-template-card="email"]';
const TEMPLATE_CARD_REMOVE_SELECTOR = '[data-template-card-remove="true"]';
const TEMPLATE_CARD_KEY_ATTRIBUTE = "data-template-card-key";
const editorInstance = ref<CKEditorInstance | null>(null);

const handleEditorReady = (editor: CKEditorInstance) => {
  editorInstance.value = editor;
};

const handleEditorDestroy = () => {
  editorInstance.value = null;
};

// Insertar una plantilla
const insertTemplateAtCursor = (html: string) => {
  const editor = editorInstance.value;
  if (!editor || !html?.trim()) return false;

  try {
    editor.model.insertContent(
      editor.data.toModel(editor.data.processor.toView(html)),
      editor.model.document.selection
    );
    editor.editing.view.focus();
    return true;
  } catch (error) {
    console.error("Error inserting HTML at cursor:", error);
    return false;
  }
};

const removeTemplateCardFromHtml = (html: string, templateCardKey: string | null) => {
  if (!html?.trim()) return html || "";

  try {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const templateCards = Array.from(
      parsed.querySelectorAll<HTMLElement>(TEMPLATE_CARD_SELECTOR)
    );

    if (!templateCards.length) return html;

    let templateCardToRemove: HTMLElement | undefined;

    if (templateCardKey) {
      templateCardToRemove = templateCards.find(
        (templateCard) =>
          templateCard.getAttribute(TEMPLATE_CARD_KEY_ATTRIBUTE) === templateCardKey
      );
    }

    if (!templateCardToRemove) {
      templateCardToRemove = templateCards[0];
    }

    templateCardToRemove?.remove();

    return parsed.body.innerHTML.trim();
  } catch (error) {
    console.error("Error removing template card:", error);
    return html;
  }
};

const handleTemplateCardActionClick = (event: MouseEvent) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  const removeAction = target.closest<HTMLElement>(TEMPLATE_CARD_REMOVE_SELECTOR);
  if (!removeAction) return;

  event.preventDefault();
  event.stopPropagation();

  const templateCardKey = removeAction.getAttribute(TEMPLATE_CARD_KEY_ATTRIBUTE);
  formState.value.text = removeTemplateCardFromHtml(formState.value.text || "", templateCardKey);
};

const handleAddEmoji = (emoji: string) => {
  const lastClosingTagIndex = formState.value.text.lastIndexOf("</p>");

  const inputText = formState.value.text;

  formState.value.text =
    inputText.slice(0, lastClosingTagIndex) + emoji + inputText.slice(lastClosingTagIndex);
};

const handleInsertTemplate = (templatesHtml: string, templatesCount = 1) => {
  if (!templatesHtml?.trim()) return;

  // Deja un párrafo vacío al final para que el cursor quede separado de la plantilla.
  if (!insertTemplateAtCursor(`${templatesHtml.trim()}<p>&nbsp;</p>`)) return;

  const insertedTemplateCount = templatesCount > 0 ? templatesCount : 1;
  message.success(
    insertedTemplateCount === 1
      ? "Plantilla insertada con éxito."
      : "Plantillas insertadas con éxito."
  );
};

defineExpose({ formState, file, files, fromEmailAddress});

const showCC = ref(false);
const showCCO = ref(false);

// Altura máxima de Para/CC/CCO según cuántos campos de destinatarios están visibles
const RECIPIENTS_MAX_HEIGHT: Record<number, number> = { 1: 160, 2: 72, 3: 56 };
const recipientsMaxHeight = computed(() => {
  const visibleFields = 1 + Number(showCC.value) + Number(showCCO.value);
  return `${RECIPIENTS_MAX_HEIGHT[visibleFields]}px`;
});

// Keys para forzar re-mount de los a-select después de paste programático
const selectKeyPara = ref(0);
const selectKeyCC = ref(0);
const selectKeyCCO = ref(0);

const searchValuePara = ref("");
const searchValueCC = ref("");
const searchValueCCO = ref("");

const currentSearch = ref({
  selectedItems: '',
  selectedItemsCC: '',
  selectedItemsCCO: ''
});
// const transmitter = ref<string>("Ventas Score <ventas@securitec.pe>");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const options = ref<any>([]);

const store = useStore();

// #TODO: cambiar inject de menu items por computed
// const menuItems = inject("menuItems") as Ref<IMenutem[]>;
const menuItems = computed(() => {
  return store.getters.getMenuItems;
});

const handleLoadDraft = () => {
  const userId = localStorage.getItem("used_id") || '';
  const draft = localStorage.getItem(DRAFT_KEY);

  const existing = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null') || null;

  console.log(existing, 'draft files existing');
  if (draft && existing) {
    try {
      const parsed = existing[userId] || null;

      console.log(parsed, 'draft files parsed');
      if (parsed) {
        formState.value = {
          fromEmail: parsed.fromEmail ?? null,
          sendAsAlias: parsed.sendAsAlias ?? null,
          selectedItems: parsed.selectedItems ?? [],
          selectedItemsCC: parsed.selectedItemsCC ?? [],
          selectedItemsCCO: parsed.selectedItemsCCO ?? [],
          subject: parsed.subject ?? "",
          text: parsed.text ?? "",
          defaultSignatureApplied: parsed.defaultSignatureApplied ?? false,
        };

        // files.value = parsed.files ?? [];
        files.value = store.getters["getDraftFiles"]?.(userId) ?? [];
      }
    } catch (error) {
      console.error("Error cargando borrador:", error);
    }
  }
}

const signatureLoading = ref(false);

const normalizeHtml = (html: string) =>
  html.replace(/&nbsp;/g, " ").replace(/\s+/g, " ").replace(/>\s+</g, "><").trim();

const SIGNATURE_SPACING_HTML = "<p><br></p><p><br></p><p><br></p>";

const appendDefaultSignature = async () => {
  const shouldUseReplySignature = props.isReply;

  if (!shouldUseReplySignature && !props.open) return;
  if (formState.value.defaultSignatureApplied) return;
  if (signatureLoading.value) return;

  signatureLoading.value = true;

  try {
    const signatures = await emailService.getSignatureList();
    const signature = signatures.find((item) =>
      shouldUseReplySignature ? item.is_reply_forward : item.is_new_message
    );

    if (!signature?.content_html) return;

    const currentText = formState.value.text ?? "";
    const normalizedCurrentText = normalizeHtml(currentText);
    const normalizedSignature = normalizeHtml(signature.content_html);

    if (normalizedCurrentText.includes(normalizedSignature)) {
      formState.value.defaultSignatureApplied = true;
      return;
    }

    formState.value.text = `${currentText}${SIGNATURE_SPACING_HTML}${signature.content_html}`;
    formState.value.defaultSignatureApplied = true;
  } catch (error) {
    console.error("Error cargando firma predeterminada:", error);
  } finally {
    signatureLoading.value = false;
  }
};

onMounted(async () => {
  if (formState.value) {
    showCC.value = formState.value.selectedItemsCC.length > 0 ? true : false;
    showCCO.value = formState.value.selectedItemsCCO.length > 0 ? true : false;
    // formState.value = props.defaultEmail;
  }
  if (!props.isReply) {
    handleLoadDraft();
    if (props.open) {
      void appendDefaultSignature();
    }
  } else {
    void appendDefaultSignature();
  }
});
;

const aliasesPerIdentifier = ref<Record<number, { id: number; email: string }[]>>({});

const loadAliasesForIdentifier = async (identifierId: number) => {
  if (aliasesPerIdentifier.value[identifierId] !== undefined) return;
  try {
    const data = await fetchSendAsAliases(identifierId);
    const list = Array.isArray(data) ? data : (data?.results || []);
    aliasesPerIdentifier.value = { ...aliasesPerIdentifier.value, [identifierId]: list };
  } catch {
    aliasesPerIdentifier.value = { ...aliasesPerIdentifier.value, [identifierId]: [] };
  }
};

// Computed que representa la opción compuesta seleccionada en el De:
// Formato: "id:<identifierId>" o "alias:<identifierId>:<aliasEmail>"
const selectedFromOption = computed({
  get() {
    if (!formState.value.fromEmail) return undefined;
    if (formState.value.sendAsAlias) {
      return `alias:${formState.value.fromEmail}:${formState.value.sendAsAlias}`;
    }
    return `id:${formState.value.fromEmail}`;
  },
  set(val: string | undefined) {
    // handled by handleFromChange
  },
});

const handleFromChange = (val: string) => {
  if (!val) {
    formState.value.fromEmail = null;
    formState.value.sendAsAlias = null;
    return;
  }
  if (val.startsWith('alias:')) {
    const parts = val.split(':');
    // alias:<identifierId>:<email> — email may contain ":" so rejoin from index 2
    const identifierId = parts[1];
    const aliasEmail = parts.slice(2).join(':');
    formState.value.fromEmail = identifierId;
    formState.value.sendAsAlias = aliasEmail;
  } else {
    // id:<identifierId>
    formState.value.fromEmail = val.replace('id:', '');
    formState.value.sendAsAlias = null;
  }
};

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen && !props.isReply) {
      void appendDefaultSignature();
    }
  }
);

const addresseeOptions = computed(() => {
  const identifiers = menuItems?.value.flatMap((i: IMenutem) => i.subItems);

  if (identifiers) {
    return identifiers.map((i: { title: string; id: number; email: string }) => ({
      name: i.title,
      id: i.id,
      email: i.email,
    }));
  }

  return [];
});

// Load aliases for every email identifier as soon as they become available
watch(
  addresseeOptions,
  (opts) => {
    opts.forEach((opt: { id: number }) => {
      loadAliasesForIdentifier(opt.id);
    });
  },
  { immediate: true }
);

watch(
  [aliasesPerIdentifier, () => formState.value.fromEmail, () => formState.value.sendAsAlias],
  () => {
    const fromId = Number(formState.value.fromEmail);
    const sendAs = formState.value.sendAsAlias;
    if (fromId && sendAs) {
      const list = aliasesPerIdentifier.value[fromId];
      if (list !== undefined) {
        const isValid = list.some((alias) => alias.email === sendAs);
        if (!isValid) {
          formState.value.fromEmail = null;
          formState.value.sendAsAlias = null;
        }
      }
    }
  },
  { deep: true }
);

const shouldRenderPopover = computed(() => {
  return (value: string) => {
    const color = getTagColor(value);
    return color !== "red";
  };
});

const getTagIcon = (value: string) => {
  const color = getTagColor(value);
  return {
    green: UserOutlined,
    orange: UserAddOutlined,
    red: CloseCircleOutlined,
  }[color];
};

const shouldRenderIcon = (value: string) => {
  return getTagColor(value) !== "red";
};

const isValidEmail = (email: string): boolean => {
  const emailRegex = new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);
  return emailRegex.test(email);
};

const getTagColor = (value: string) => {
  const containEmail = options.value.some((option: any) => option.email === value);
  const isValid = isValidEmail(value);

  return containEmail ? "green" : isValid ? "orange" : "red";
};

let errorModalDisplayed = false;

const displayName = (value: string) => {
  const contact = options.value.find((option: { email: string; name: string }) => option.email === value);
  // return contact?.name || "Contacto no identificado";
  return contact?.name || `No identificado <${value}>`;
};

const displayErrorModal = (email: string) => {
  Modal.error({
    title: "Haz ingresado correos inválidos",
    content: `No se ha podido reconocer la dirección  “${email}”. Asegúrate de que todas las direcciones tengan el formato correcto.`,
    onOk() {
      errorModalDisplayed = false;
    },
  });
};

const validateEmails = (emails: string[]) => {
  const invalid = emails.find(e => !isValidEmail(e));
  if (invalid && !errorModalDisplayed) {
    errorModalDisplayed = true;
    displayErrorModal(invalid);
  }
};

const handleChangeEmailFrom = () => {
  emit("handleChangeEmailFrom");
};

const fetchEmails = debounce(async function (event) {
  console.log(event, "event");
  console.log(selectedCampaign.value, "selectedCampaign.value");
  const data = await emailService.getEmailIdentifiers(selectedCampaign.value.channelCustomerId, event);
  options.value = data;
  console.log(data, "data");
}, 300);

// Normalize emails
const normalizeEmails = (emails: string[]): string[] => {
  return emails
    .flatMap((email) => (typeof email === 'string' ? email.split(/[,\n\r;]+/) : []))
    .map((email) => email.trim())
    .filter((email) => email.length > 0);
};

const getPopupContainer = (triggerNode: HTMLElement) => {
  return triggerNode.parentNode as HTMLElement;
};

const handleSearch = (val: string, field: 'selectedItems' | 'selectedItemsCC' | 'selectedItemsCCO') => {
  if (field === 'selectedItems') searchValuePara.value = val;
  else if (field === 'selectedItemsCC') searchValueCC.value = val;
  else searchValueCCO.value = val;

  currentSearch.value[field] = val;
  fetchEmails(val);
};

const handleBlur = (field: 'selectedItems' | 'selectedItemsCC' | 'selectedItemsCCO') => {
  const searchRef = field === 'selectedItems' ? searchValuePara : (field === 'selectedItemsCC' ? searchValueCC : searchValueCCO);
  const val = searchRef.value.trim();

  // Limpiar inmediatamente el search value para evitar fugas al siguiente campo
  searchRef.value = '';
  currentSearch.value[field] = '';

  if (val) {
    if (!formState.value[field].includes(val)) {
      formState.value[field] = [...formState.value[field], val];

      nextTick(() => {
        if (field === 'selectedItems') {
          selectKeyPara.value++;
          nextTick(() => selectParaRef.value?.focus());
        } else if (field === 'selectedItemsCC') {
          selectKeyCC.value++;
          nextTick(() => selectCCRef.value?.focus());
        } else {
          selectKeyCCO.value++;
          nextTick(() => selectCCORef.value?.focus());
        }
      });
    }
  }
};

const handleKeydown = (event: KeyboardEvent, field: 'selectedItems' | 'selectedItemsCC' | 'selectedItemsCCO') => {
  const isTriggerKey = event.key === 'Enter'
    || event.key === 'Tab'
    || event.key === ';'
    || event.code === 'Semicolon';

  if (!isTriggerKey) return;

  const searchRef = field === 'selectedItems'
    ? searchValuePara
    : field === 'selectedItemsCC'
      ? searchValueCC
      : searchValueCCO;

  const val = searchRef.value.trim();

  if (!val) return;

  event.preventDefault();
  event.stopPropagation();

  if (!formState.value[field].includes(val)) {
    formState.value[field] = [...formState.value[field], val];
  }

  searchRef.value = '';
  currentSearch.value[field] = '';

  nextTick(() => {
    if (field === 'selectedItems') {
      selectKeyPara.value++;
      nextTick(() => selectParaRef.value?.focus());
    } else if (field === 'selectedItemsCC') {
      selectKeyCC.value++;
      nextTick(() => selectCCRef.value?.focus());
    } else {
      selectKeyCCO.value++;
      nextTick(() => selectCCORef.value?.focus());
    }
  });
};

// Intercepta el evento paste para separar correos pegados con
// saltos de línea o comas. El <input> de a-select elimina los \n
// al pegar, por eso se necesita interceptar aquí.
const handleEmailPaste = (
  event: ClipboardEvent,
  field: 'selectedItems' | 'selectedItemsCC' | 'selectedItemsCCO'
) => {
  const pastedText = event.clipboardData?.getData('text');
  if (!pastedText) return;

  // Solo interceptar si el texto contiene separadores (comas, punto y coma o saltos de línea)
  if (/[,\n\r;]/.test(pastedText)) {
    event.preventDefault();
    event.stopPropagation();

    const emails = pastedText
      .split(/[,\n\r;]+/)
      .map((e) => e.trim())
      .filter((e) => e.length > 0);

    formState.value[field] = [...formState.value[field], ...emails];

    // Forzar re-mount del a-select para sincronizar su estado interno
    nextTick(() => {
      if (field === 'selectedItems') {
        selectKeyPara.value++;
        nextTick(() => selectParaRef.value?.focus());
      } else if (field === 'selectedItemsCC') {
        selectKeyCC.value++;
        nextTick(() => selectCCRef.value?.focus());
      } else {
        selectKeyCCO.value++;
        nextTick(() => selectCCORef.value?.focus());
      }
    });
  }
};

// Watcher para normalizar correos en "Para"
watch(
  () => formState.value.selectedItems,
  (newVal) => {
    const normalized = normalizeEmails(newVal);
    if (JSON.stringify(normalized) !== JSON.stringify(newVal)) {
      formState.value.selectedItems = normalized;
    }
    validateEmails(normalized);
  },
  { deep: true }
);

// Watcher para normalizar correos en "CC"
watch(
  () => formState.value.selectedItemsCC,
  (newVal) => {
    const normalized = normalizeEmails(newVal);
    if (JSON.stringify(normalized) !== JSON.stringify(newVal)) {
      formState.value.selectedItemsCC = normalized;
    }
    validateEmails(normalized);
  },
  { deep: true }
);

// Watcher para normalizar correos en "CCO"
watch(
  () => formState.value.selectedItemsCCO,
  (newVal) => {
    const normalized = normalizeEmails(newVal);
    if (JSON.stringify(normalized) !== JSON.stringify(newVal)) {
      formState.value.selectedItemsCCO = normalized;
    }
    validateEmails(normalized);
  },
  { deep: true }
);

// const onClose = (removedTag) => {
//   const newSelectedItems = selectedItems.value.filter((item) => item !== removedTag);
//   selectedItems.value = newSelectedItems;
// };

watch(
  () => formState.value,
  (newValue) => {
    if (newValue) {
      showCC.value = newValue.selectedItemsCC.length > 0 ? true : false;
      showCCO.value = newValue.selectedItemsCCO.length > 0 ? true : false;
      // formState.value = props.defaultEmail;
    }
  }
);
</script>
<style lang="sass" scoped>
p
  margin: 0
.option
  .first
    display: none

  p
    font-size: 12px
    color: rgba(0, 0, 0, 0.45)
    margin: 0


.send-email
  :deep(.ant-select-multiple .ant-select-selector)
    max-height: var(--recipients-max-height, 56px)
    overflow-y: auto
    align-items: flex-start
  .link
    display: flex
    gap: 5px
    align-items: center
    flex-shrink: 0
    button
      margin: 0
      padding: 0 5px
.flex-container
  display: flex
  width: 100%
  gap: 10px
  align-items: center
.ant-form-item
  margin-bottom: 7px

.editor-drop-zone
  position: relative

.editor-drop-zone.dragging
  border: 2px dashed #4096ff
  background: #f0f7ff
</style>
<style>
.general .identifier .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.general .transfer {
  display: flex;
  align-items: center;
  gap: 5px;
}

.general .transfer button {
  margin: 0;
  padding: 0;
}

.general .transfer svg path {
  fill: #1677ff;
}
</style>
